import { Text } from '@oneaudi/unified-web-components';
import React, { memo } from 'react';
import styled from 'styled-components';
import { convertRichText } from '../../utils/convertRichText';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import { isClient, sanitizeHtml } from '../../utils/utils';

const StyledText = styled(Text)`
  & a {
    color: inherit;
  }
  & p {
    margin: 0;
    padding: 0;

    & + p {
      margin-block-start: var(--spacing-relative-md);
    }
  }
  ol,
  ul li {
    display: list-item;
    line-height: 1.5;
  }
`;

export interface RichTextProps {
  readonly text: string;
}

export const RichText = memo(function RichText({ text }: RichTextProps) {
  if (isClient) {
    const richText = convertRichText(text);
    const renderedText = Array.isArray(richText)
      ? richText.map((item) =>
          typeof item === 'string' ? renderTextWithFootnotesReferencesV2(item) : item,
        )
      : renderTextWithFootnotesReferencesV2(richText as string);
    return <StyledText tag="span">{renderedText} </StyledText>;
  } else {
    const sanitizedHtml = sanitizeHtml(text);
    return (
      <StyledText>
        <span id="anchors-allowed" dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
      </StyledText>
    );
  }
});
